module.exports = __webpack_public_path__ + "static/media/62pic.6de390bf.jpg";